import {Component, OnInit} from '@angular/core';
import {HeaderService} from "../header.service";
import {NavigationStart, Router} from "@angular/router";
import {DisplayService} from "../../../services/display.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {GamesService} from "../../../services/games.service";
import {SubmenuItem} from "../../../interfaces/submenu-item";
import {RankingService} from "../../../services/ranking.service";
import {TrophyService} from "../../../services/trophy.service";
import {AuthService} from "../../../auth/auth.service";
import {SchoolClassData} from "../../../interfaces/school-class-data";
import {StudentAuthService} from "../../../services/student-auth.service";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-mobile-game-header-menu',
  templateUrl: './mobile-game-header-menu.component.html',
  styleUrls: ['./mobile-game-header-menu.component.scss']
})
export class MobileGameHeaderMenuComponent implements OnInit {
  searchText: string = "";


  state = false;

  schoolClassData?: SchoolClassData;
  menuGames: SubmenuItem[] = [];

  constructor(
    private headerService: HeaderService,
    private router: Router,
    private display: DisplayService,
    private gamesService: GamesService,
    private rankingService: RankingService,
    private trophyService: TrophyService,
    private authService: AuthService,
    private studentAuthService: StudentAuthService,
    ) {
  }

  ngOnInit() {

    this.studentAuthService.onLogInStateChanged().pipe(untilDestroyed(this)).subscribe((state) => {
      if(state) {
        this.schoolClassData = this.studentAuthService.getClassData();
      }
    })


    this.menuGames = this.gamesService.getSubmenuItems();


    this.headerService.onMobileGameMenuStateChanged().pipe(untilDestroyed(this)).subscribe((newVal) => {
      this.state = newVal;
      if(this.state) {
        this.display.disableBodyScroll();
      } else {
        this.display.enableBodyScroll();
      }
    })

    this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
      if(event instanceof NavigationStart) {
        this.headerService.setMobileGameMenuState(false);
      }
    })
  }



  toggleMenuItem(menuItem: HTMLDivElement) {
    menuItem.classList.toggle("opened");
  }


  openRankingListOverlay() {
    this.headerService.setMobileGameMenuState(false);
    this.rankingService.openRankingOverlay();
  }

  openTrophiesOverlay() {
    this.headerService.setMobileGameMenuState(false);
    this.trophyService.openTrophiesOverlay(123);

  }
  logout() {
    this.authService.logout();
  }
}
